import React, { forwardRef, useMemo } from 'react';

import { validate } from '@vlabs/shared';

import { useEventApi, useApiData } from '@vlabs/monokit/entities/events/api';
import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFilters } from '../../useEventListFilters';

function HandlersFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useEventListFilters();
  const api = useEventApi();
  const { data: options } = useApiData(async () => api.getHandlerOptions());
  const handlerOptions = useMemo(() => options ?? [], [options]);

  const selectedHandlerIds = filters.handler_ids ?? [];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedHandlerIds.length === 0}
      onClickReset={() => updateFilters({ handler_ids: undefined })}
      ref={ref}
    >
      <OptionsFilter
        isCreatable
        name="handler_ids"
        onChange={(value) => updateFilters({ handler_ids: value })}
        options={handlerOptions}
        validateProp={validate.UUIDValidator()}
        value={selectedHandlerIds}
        visibleCount={5}
      />
    </PopoverWithButton>
  );
}

const HandlersFilterPopoverWithRef = forwardRef(HandlersFilterPopover);
export { HandlersFilterPopoverWithRef as HandlersFilterPopover };
